import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web que obtiene las ayudas
   * Autor: Diego Diaz
   * @param filter filtro de ayudas
   * @return N/A
   */
  getHelpTopics(filter){
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_HELP_TOPICS, { "value":filter });
  }
}
